<template>
  <div id="app">

    <!-- <img alt="Vue logo" src="./assets/logo.png"> -->
    <Navbar v-bind:mainPage="currentRoute == '/'"/>
    <HelloWorld v-if="currentRoute == '/'"/>
    <Privacy v-if="currentRoute == '/polityka-prywatnosci'"/>
    <Article v-if="currentRoute == '/kiedy-zlozyc-wypowiedzenie'"/>
    <Footer/>
  </div>
</template>

<script>
import Vue from 'vue'
import HelloWorld from './components/HelloWorld.vue'
import Navbar from './components/Navbar.vue'
import Footer from './components/Footer.vue'
import Privacy from './components/Privacy.vue'
import Article from './components/Article.vue'
import VueI18n from 'vue-i18n'

Vue.use(VueI18n);

export default {
  name: 'app',
  data: function() {
    return {
    currentRoute: window.location.pathname
    }
  },
  components: {
    HelloWorld,
    Navbar,
    Footer,
    Privacy,
    Article,
  }
}
</script>